export default __webpack_public_path__ + "static/media/asset_template.3ab0fd4a.xlsx";